/* global searchFormToggle */
import ToggleableComponent from "./ToggleableComponent";

export default class MobileMenu {

  constructor(button) {
    this.mobileMenu = new ToggleableComponent(
      document.querySelector('.region-header .menu-icon'),
      document.querySelector('.menu--main > .menu')
    );

    this.setup();
  }

  deactivate() {
    this.mobileMenu.deactivate();
  }

  setup() {
    if (!this.mobileMenu) {
      return;
    }

    this.mobileMenu.toggleCallback = function (toggled) {

      if (toggled) {
        document.body.classList.add('mobile-menu-opened');
      } else {
        document.body.classList.remove('mobile-menu-opened')
      }

      if (toggled && (typeof searchFormToggle !== 'undefined')) {
        // Close search if mobile menu opened.
        (typeof searchFormToggle.deactivate !== 'undefined') && searchFormToggle.deactivate();
      }
    }
  }
}
